interface ImproveButtonProps {
    title: string;
    description: string;
    icon: string;
}

const TRAINING_DESCRIPTION = "Model Retraining - we'll email you when it's ready";

interface Options {
    willPublish?: boolean;
    iconStyle?: string;
}

export function getImproveButtonProps(
    isTraining: boolean,
    loading: boolean,
    { willPublish = true, iconStyle = "far" }: Options = {}
): ImproveButtonProps {
    const defaultDescription = willPublish
        ? "Publish and retrain on new data."
        : "Retrain on new data.";

    if (isTraining) {
        return {
            title: "Improve Model",
            description: TRAINING_DESCRIPTION,
            icon: "far fa-spinner fa-spin"
        };
    }

    if (loading) {
        return {
            title: "Gathering data...",
            description: defaultDescription,
            icon: "far fa-spinner fa-spin"
        };
    }

    return {
        title: "Improve Model",
        description: defaultDescription,
        icon: `${iconStyle} fa-sparkles`
    };
}
